<template>
  <v-dialog
    :value="show"
    @input="$emit('close', $event)"
    max-width="500">
    <v-card class="pa-5">
      <v-row class="pl-5 pr-3">
        <v-card-title class="headline text-primary pb-5" style="align-self: flex-start;">{{ title }}</v-card-title>
        <v-card-actions class="ml-auto">
          <v-btn icon @click="$emit('close')">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-row>
      <v-card-text class="text-secondary">
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="cnl-btn px-8"
          text
          @click="$emit('cancel')"
        >{{ $t('common.cancelBtn') }}
        </v-btn>
        <v-btn
          class="red-btn white--text px-8 ml-6"
          text
          @click="$emit('confirm')"
        >{{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: 'Confirm Action'
    },
    message: {
      type: String,
      default: 'Are you sure you want to perform this action?'
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    icons: {
      type: Object,
      required: true // Assuming mdiClose is passed from the parent
    }
  },
  emits: ['close', 'cancel', 'confirm']
};
</script>
<style>

</style>